// Author Lidongxu
// Date 2025-06-03 11:23:55

import * as model from "@/model/em/archive/EmStocktakingTaskModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmStocktakingTask(), newFilter)
        .withStates({
            baseModuleUrl: process.env.VUE_APP_EM_ARCHIVE_URL,
        })
        .withPatternFactory(customVuexFilterPatternFactory, {
            filterState: 'qualityFilter',
            filterInitializer: newFilter
        })
        .buildStore()
